import React, { useState } from 'react';
import NewInvoiceForm from './NewInvoiceForm';
import { Grid, Typography, Select, MenuItem } from "@mui/material";
import Spinner from '../Spinner';
import intl from 'components/i18n/ReactIntlWrapper';
import ErrorSummary from '../common/ErrorSummary';
import NewInvoiceDropZone from './NewInvoiceDropZone'
import { useNewInvoice } from './newInvoiceProvider';

const NewInvoiceMain = ({review = false, view = false}) => {

    const { isManualCreation, billFromPersonas, isBillFromPersonasLoading, setInput, input, isLoading, errors, setErrors } = useNewInvoice();
    const [disabled, setDisabled] = useState(false);

    const handlePersonaChange = (e) => {
        setInput({
            ...input,
            idFrom: e,
            from: billFromPersonas.find(persona => persona.id === e).name
        });
        setErrors(prevErrors => ({
            ...prevErrors,
            [`idFrom`]: ""
        }));
    };

    return (
        <div className='container'>
            <div className='card mt-4'>
                {isLoading && <Spinner />}
                <div className="card-header">
                    <h2 className="title">{review ? intl.get('newInvoice.validation') : intl.get('newInvoice.header')}</h2>
                </div>
                <div className='card-body'>
                    <Grid container xl={12}>
                        <Grid item xl={12}>
                            <ErrorSummary errors={errors} showEverything={true} ></ErrorSummary>
                        </Grid>
                    </Grid>
                    <Grid container xl={12} className='justify-content-around'>
                        <Grid container item xl={12}>
                            <Grid item xl={6}>
                                <Typography className={`${errors?.idFrom ? 'text-danger' : ''}`} style={{marginTop: errors?.idFrom && errors?.idFrom !== "missing confidence" ? "-30px" : "0px"}}>
                                    {errors?.idFrom && errors?.idFrom !== "missing confidence" && (<span className='text-danger'>{errors?.idFrom}</span>)}
                                </Typography>
                                {view ? (
                                    <input 
                                        type="text"
                                        value={input.personaFrom?.name || ''}
                                        disabled={true}
                                        style={{width: '100%', padding: '8px'}}
                                    />
                                ) : (
                                    <Select
                                    id='idFrom'
                                    name='idFrom'
                                    value={input?.idFrom}
                                    size='small'
                                    displayEmpty
                                    fullWidth
                                    inputProps={{placeholder: intl.get('newInvoice.invoiceSelectProfile')}}
                                    onChange={(e) => {handlePersonaChange(e.target.value)}}
                                    error={errors?.idFrom ? true : false}
                                    disabled={isBillFromPersonasLoading || !review}
                                >
                                    <MenuItem disabled value="">
                                        <em>{intl.get('newInvoice.invoiceSelectProfile')}</em>
                                    </MenuItem>
                                    {billFromPersonas?.map((persona) => (
                                        <MenuItem
                                            key={persona.id}
                                            value={persona.id}
                                        >
                                            {persona.name}
                                        </MenuItem>
                                    ))}
                                    </Select>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <hr/>
                    <Grid container xl={12}>
                        <Grid md={(isManualCreation || (!input["attachments"]?.[0] && view)) ? 0 : 5}>
                            <NewInvoiceDropZone files={input["attachments"]} review={review} view={view}/>
                        </Grid>
                        <Grid md={(isManualCreation || (!input["attachments"]?.[0] && view)) ? 12 : 7}>
                            <NewInvoiceForm disabled={disabled} review={review} view={view} />
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )
};

export default NewInvoiceMain;
